var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <h2 class=\"h3\" data-link=\""
    + container.escapeExpression((lookupProperty(helpers,"getFilmDetailUrl")||(depth0 && lookupProperty(depth0,"getFilmDetailUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"slug") : depth0),{"name":"getFilmDetailUrl","hash":{},"data":data,"loc":{"start":{"line":3,"column":28},"end":{"line":3,"column":60}}}))
    + "\">\n    "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"filmTitle") : depth0), depth0)) != null ? stack1 : "")
    + "\n  </h2>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <h2 class=\"h3\">\n    "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"filmTitle") : depth0), depth0)) != null ? stack1 : "")
    + "\n  </h2>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <h3 class=\"h4\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"subTitle") : depth0), depth0)) != null ? stack1 : "")
    + "</h3>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"teaser") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <p>\n    "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"shortText") : depth0), depth0)) != null ? stack1 : "")
    + "\n  </p>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"slug") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":10,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"subTitle") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":0},"end":{"line":14,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"teaser") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":0},"end":{"line":17,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = container.invokePartial(require("./movie-attributes-hbs.hbs"),depth0,{"name":"./movie-attributes-hbs.hbs","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"shortText") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":0},"end":{"line":24,"column":7}}})) != null ? stack1 : "")
    + "<div>\n  <a href=\""
    + container.escapeExpression((lookupProperty(helpers,"getFilmDetailUrl")||(depth0 && lookupProperty(depth0,"getFilmDetailUrl"))||container.hooks.helperMissing).call(alias1,(depth0 != null ? lookupProperty(depth0,"slug") : depth0),{"name":"getFilmDetailUrl","hash":{},"data":data,"loc":{"start":{"line":26,"column":11},"end":{"line":26,"column":41}}}))
    + "\" class=\"btn btn-outline\">\n    <span>Mehr erfahren</span>\n    <ui-icon icon=\"arrow-20\"></ui-icon>\n  </a>\n</div>\n";
},"usePartial":true,"useData":true});